export const EPIC_SYSTEM = [
  {
    type: "text",
    fieldName: "connection_name",
    label: "Name*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "client_id",
    label: "Client Id*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "private_key",
    label: "Private Key*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "org_redirect_uri",
    label: "Organization Redirect URL",
    error: false,
    isReq: false,
  },
];

export const EPIC_PROVIDER = [
  {
    type: "text",
    fieldName: "connection_name",
    label: "Name*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "client_id",
    label: "Client ID*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "client_secret",
    label: "Client Secret",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "scope",
    label: "Scope",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "audiance",
    label: "Audience",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "launch",
    label: "Launch",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "org_redirect_uri",
    label: "Organization Redirect URL*",
    error: false,
    isReq: true,
  },
];

export const EPIC_PATIENT = [
  {
    type: "text",
    fieldName: "connection_name",
    label: "Name*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "client_id",
    label: "Client ID*",
    error: false,
    isReq: true,
  },
  {
    type: "text",
    fieldName: "client_secret",
    label: "Client Secret",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "scope",
    label: "Scope",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "audiance",
    label: "Audience",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "launch",
    label: "Launch",
    error: false,
    isReq: false,
  },
  {
    type: "text",
    fieldName: "org_redirect_uri",
    label: "Organization Redirect URL*",
    error: false,
    isReq: true,
  },
];
